// These match container.type from API
export const AssetContainerType = {
  HTML: 'html',
  IMAGE: 'image',
  SLIDER: 'slider',
};
